import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { useSelector } from "react-redux";

const useCurrency = (options?: Toolkit.GoogleAnalytics.Options) => {
    return useSelector((state: ApplicationState) => state.context.session.currency?.currencyCode);
};

export default useCurrency;
